import { Redirect, useRouteMatch } from 'react-router-dom';

export const VisitsRedirect: React.FC = (): JSX.Element => {
  const { url } = useRouteMatch();

  return <Redirect to={`${url}/visits`} />;
};
